import React, { useState } from 'react';

const ProfessorCard = ({ 
  image, 
  name, 
  position, 
  bio, 
  social 
}) => {
  const [showFullBio, setShowFullBio] = useState(false);
  const maxLength = 264;
  const isLongBio = bio.length > maxLength;
  const displayBio = showFullBio ? bio : bio.substring(0, maxLength) + '...';

  return (
    <div className="group glass rounded-3xl shadow-xl hover:shadow-2xl transition-all duration-500 p-8 text-center transform hover:-translate-y-3 border border-white/20 h-full flex flex-col">
      {/* Enhanced Professor Image */}
      <div className="relative mb-6">
        <div className="w-32 h-32 mx-auto relative group">
          <img 
            src={image} 
            alt={name} 
            className="w-full h-full object-cover rounded-full border-4 border-white shadow-2xl group-hover:scale-105 transition-transform duration-500"
          />
          {/* <div className="absolute -top-2 -right-2 w-8 h-8 bg-gradient-to-br from-blue-500 to-purple-500 rounded-full flex items-center justify-center shadow-lg">
            <span className="text-white text-xs font-bold">AI</span>
          </div> */}
          
          {/* Glowing ring effect */}
          <div className="absolute inset-0 rounded-full border-2 border-brand-primary/30 animate-pulse-glow"></div>
        </div>
      </div>
      
      {/* Enhanced Professor Info */}
      <div className="space-y-4 flex-1 flex flex-col">
        <div>
          <h3 className="text-h5 font-display font-bold gradient-text group-hover:scale-105 transition-transform duration-300 mb-2 tracking-tight">
            {name}
          </h3>
          <p className="text-brand-primary font-display font-semibold text-body-small tracking-wide mb-4">{position}</p>
        </div>

        {/* Bio */}
        <div className="flex-1">
          <p className="text-body-small text-gray-600 leading-relaxed text-justify font-body">
            {displayBio}
          </p>
          {isLongBio && (
            <button 
              onClick={() => setShowFullBio(!showFullBio)}
              className="text-brand-primary hover:text-brand-secondary font-body font-medium text-caption mt-2 transition-colors duration-200 tracking-wide"
            >
              {showFullBio ? 'Thu gọn' : 'Xem thêm'}
            </button>
          )}
        </div>
        
        {/* Enhanced Social Links */}
        <div className="flex justify-center space-x-3 pt-6 mt-auto">
          {social?.linkedin && (
            <button className="w-10 h-10 bg-brand-primary text-white rounded-lg flex items-center justify-center hover:bg-brand-secondary transition-all duration-300 transform hover:scale-110 shadow-lg hover:shadow-xl">
              <svg className="w-4 h-4" fill="currentColor" viewBox="0 0 24 24">
                <path d="M20.447 20.452h-3.554v-5.569c0-1.328-.027-3.037-1.852-3.037-1.853 0-2.136 1.445-2.136 2.939v5.667H9.351V9h3.414v1.561h.046c.477-.9 1.637-1.85 3.37-1.85 3.601 0 4.267 2.37 4.267 5.455v6.286zM5.337 7.433c-1.144 0-2.063-.926-2.063-2.065 0-1.138.92-2.063 2.063-2.063 1.14 0 2.064.925 2.064 2.063 0 1.139-.925 2.065-2.064 2.065zm1.782 13.019H3.555V9h3.564v11.452zM22.225 0H1.771C.792 0 0 .774 0 1.729v20.542C0 23.227.792 24 1.771 24h20.451C23.2 24 24 23.227 24 22.271V1.729C24 .774 23.2 0 22.222 0h.003z"/>
              </svg>
            </button>
          )}
          {social?.twitter && (
            <button className="w-10 h-10 bg-brand-secondary text-white rounded-lg flex items-center justify-center hover:bg-brand-dark transition-all duration-300 transform hover:scale-110 shadow-lg hover:shadow-xl">
              <svg className="w-4 h-4" fill="currentColor" viewBox="0 0 24 24">
                <path d="M24 4.557c-.883.392-1.832.656-2.828.775 1.017-.609 1.798-1.574 2.165-2.724-.951.564-2.005.974-3.127 1.195-.897-.957-2.178-1.555-3.594-1.555-3.179 0-5.515 2.966-4.797 6.045-4.091-.205-7.719-2.165-10.148-5.144-1.29 2.213-.669 5.108 1.523 6.574-.806-.026-1.566-.247-2.229-.616-.054 2.281 1.581 4.415 3.949 4.89-.693.188-1.452.232-2.224.084.626 1.956 2.444 3.379 4.6 3.419-2.07 1.623-4.678 2.348-7.29 2.04 2.179 1.397 4.768 2.212 7.548 2.212 9.142 0 14.307-7.721 13.995-14.646.962-.695 1.797-1.562 2.457-2.549z"/>
              </svg>
            </button>
          )}
          {social?.website && (
            <button className="w-10 h-10 bg-brand-dark text-white rounded-lg flex items-center justify-center hover:bg-brand-primary transition-all duration-300 transform hover:scale-110 shadow-lg hover:shadow-xl">
              <svg className="w-4 h-4" fill="currentColor" viewBox="0 0 24 24">
                <path d="M12 0C5.373 0 0 5.373 0 12s5.373 12 12 12 12-5.373 12-12S18.627 0 12 0zm-2 16l-4-4 1.414-1.414L10 14.172l7.586-7.586L19 8l-9 9z"/>
              </svg>
            </button>
          )}
        </div>
      </div>
    </div>
  );
};

export default ProfessorCard; 